import React from 'react';
import { useOutletContext } from 'react-router';
import InfoCards from './InfoCards';

function InfoCardsOutlet() {
  const [orderData, currentView] = useOutletContext();

  return (
    <InfoCards
      style={{
        marginTop: '1rem',
        marginBottom: '1rem',
      }}
      data={orderData}
      currentView={currentView}
    />
  );
}

export default InfoCardsOutlet;
